import React from "react";
import { Button, Flex, IconLogin, Text } from "@aws-amplify/ui-react";
import { useTranslation } from "react-i18next";
import { responsiveStyles } from "../../theme/GlobalStyles";

export default function LoginButton(props: any) {
    const { overrides: overridesProp, text, ...rest } = props;
    const overrides = { ...overridesProp };
    const { t } = useTranslation();
    return (
        <Button
            width={responsiveStyles.buttons.width}
            alignSelf="center"
            position="relative"
            className="primary-button primary-button-login">
            <Text className="loginButtonText" padding="2px" fontSize={"19px"} margin="0">
                {t("login")}
            </Text>
            <IconLogin
                padding="1px"
                //position= "absolute"
                left="185px"
                //top="17px"
                color="#183A59"></IconLogin>
        </Button>
    );
}
